import { actionTypes } from "./actions";

const initialState = {
  accountData: [],
  accountDetailData: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_ACCOUNT_BALANCE_LIST:
      return {
        ...state,
        accountData: payload,
      };
    case actionTypes.SET_ACCOUNT_BALANCE_DETAILS:
      return {
        ...state,
        accountDetailData: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
